<template>
  <header id="topnav">
    <div class="topbar-main">
      <div class="container-fluid d-flex align-items-center justify-content-between flex-wrap" style="min-height: 60px;">
        <div class="logo py-1">
          <router-link :to="{name: 'home'}" class="text-white">
            <img src="@/assets/logo_roadme.png" style="height: 30px;">           
          </router-link>
        </div>

        <div class="d-flex align-items-center flex-wrap py-1 ml-auto">
          <!-- Premium Global Context Pill Widget -->
          <div class="topbar-context-widget d-flex align-items-center mr-3 my-1">
            <div class="context-pill d-flex align-items-center">
              <!-- Commessa item -->
              <div class="context-pill-item d-flex align-items-center">
                <span class="pill-icon text-primary mr-2">
                  <i class="mdi mdi-briefcase-check-outline"></i>
                </span>
                <div class="pill-select-wrapper">
                  <span class="pill-tag">COMMESSA</span>
                  <select v-model="selectedCommessaId" class="pill-select">
                    <option v-for="c in commesse" :key="c.id" :value="String(c.id)">
                      {{ c.nome }} ({{ c.codice || ('Lotto ' + c.id) }})
                    </option>
                  </select>
                </div>
              </div>

              <!-- Divider -->
              <div class="pill-divider" v-if="activeModules && activeModules.length > 0"></div>

              <!-- Modulo item -->
              <div class="context-pill-item d-flex align-items-center" v-if="activeModules && activeModules.length > 0">
                <span class="pill-icon text-info mr-2">
                  <i class="mdi mdi-view-dashboard-outline"></i>
                </span>
                <div class="pill-select-wrapper">
                  <span class="pill-tag">MODULO</span>
                  <select v-model="selectedModuleId" class="pill-select">
                    <option value="">Tutti i moduli</option>
                    <option v-for="m in activeModules" :key="m.id" :value="String(m.id)">
                      {{ m.nome }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="menu-extras topbar-custom">
            <ul class="list-inline float-right mb-0">
              <li class="menu-item list-inline-item">
                <a class="navbar-toggle nav-link" :class="{'open': isMenuOpen}" @click="toggleMenu">
                  <div class="lines">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </a>
              </li>
              <li class="list-inline-item dropdown notification-list" v-if="false">
                <a
                  class="nav-link dropdown-toggle arrow-none waves-effect"
                  @click="showNotifications()"
                >
                  <i class="mdi mdi-bell noti-icon"></i>
                  <span class="badge badge-pink noti-icon-badge">{{ notifications.length }}</span>
                </a>
              </li>

              <li class="list-inline-item dropdown notification-list" v-if="false">
                <a
                  class="nav-link dropdown-toggle waves-effect nav-user"
                  @click="platformLogout()"
                >
                  <img src="../assets/logo_roadme.png" alt="user" class="rounded-circle" />
                </a>              
              </li>
            </ul>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="navbar-custom">
      <div class="container-fluid">
        <div id="navigation" :class="{'open': isMenuOpen}">
          <ul class="navigation-menu">
            <li class="has-submenu" :class="[{'active': activeDirectory=='home'}]">
              <router-link :to="{name:'home'}">
                <i class="ti-home"></i>Homepage
              </router-link>
            </li>
            <!-- === SOLO SVILUPPATORE CSI (D) === -->
            <template v-if="tipologia == 'D'">
              <!-- Gestione Aziende -->
              <li class="has-submenu" :class="[{'active': activePage=='admin-companies'}]">
                <router-link :to="{name: 'admin-companies'}">
                  <i class="ti-building"></i>Aziende
                </router-link>
              </li>
              <!-- Gestione Utenti -->
              <li class="has-submenu" :class="[{'active': activePage=='admin-users'}]">
                <router-link :to="{name: 'admin-users'}">
                  <i class="ti-user"></i>Utenti
                </router-link>
              </li>
              <!-- Catalogo Asset -->
              <li class="has-submenu" :class="[{'active': activePage=='admin-assets'}]">
                <router-link :to="{name: 'admin-assets'}">
                  <i class="ti-package"></i>Catalogo Asset
                </router-link>
              </li>
            </template>
            <!-- Mappa -->
            <li class="has-submenu" :class="[{'active': activeDirectory=='map'}]" v-if="tipologia !== 'D'">
              <router-link :to="{name:'realtime-map'}">
                <i class="ti-map"></i>Mappa
              </router-link>
            </li>
            <!-- Calendario Lavori -->
            <li class="has-submenu" :class="[{'active': activePage=='admin-calendar'}]" v-if="tipologia=='B'">
              <router-link :to="{name:'admin-calendar'}">
                <i class="ti-calendar"></i>Calendario
              </router-link>
            </li>
            <!-- Lavori Assegnati -->
            <li class="has-submenu" :class="[{'active': activePage=='admin-assigned-jobs'}]" v-if="tipologia=='B' || tipologia=='G'">
              <router-link :to="{name:'admin-assigned-jobs'}">
                <i class="ti-clipboard"></i>Lavori Assegnati
              </router-link>
            </li>
            <!-- Storico -->
            <li class="has-submenu" :class="[{'active': activeDirectory=='storico'}, {'open': activeSubmenu=='storico'}]" v-if="tipologia !== 'D'">
              <a @click.prevent="toggleSubmenu('storico')">
                <i class="ti-list"></i>Storico
              </a>
              <ul class="submenu" :class="{'open': activeSubmenu=='storico'}">
                <li><span>Anomalie e Assistenza</span></li>
                <li :class="[{'active': activePage=='segnalazioni'}]">
                  <router-link :to="{ name: 'history', params: { scope: 'segnalazioni' }}" >
                    <i class="ti-alert"></i>Segnalazioni
                  </router-link>
                </li>
                <li :class="[{'active': activePage=='richieste'}]">
                  <router-link :to="{ name: 'history', params: { scope: 'richieste' }}" >
                    <i class="ti-help-alt"></i>Richieste di supporto
                  </router-link>
                </li>
                <li class="divider"></li>
                <li><span>Interventi</span></li>
                <li :class="[{'active': activePage=='lavori'}]">
                  <router-link :to="{ name: 'history', params: { scope: 'lavori' }}" >
                    <i class="ti-briefcase"></i>Lavori
                  </router-link>
                </li>
              </ul>
            </li>            
            <!-- Dati -->
            <li class="has-submenu" :class="[{'active': activeDirectory=='dati'}, {'open': activeSubmenu=='dati'}]" v-if="tipologia !== 'D'">
               <a @click.prevent="toggleSubmenu('dati')">
                 <i class="ti-download"></i>Dati
               </a>
               <ul class="submenu" :class="{'open': activeSubmenu=='dati'}">
                 <li :class="[{'active': activePage=='geo-data'}]">
                   <router-link :to="{name: 'geo-data'}" >
                     <i class="ti-map-alt"></i>Dati geografici
                   </router-link>
                 </li>
                 <li>
                   <router-link :to="{name: 'reports'}">
                     <i class="ti-bar-chart"></i>Report giornaliero
                   </router-link>
                 </li>
               </ul>
            </li>
            <li class="has-submenu float-right-item" :class="{'open': activeSubmenu=='gestione'}">
              <a @click.prevent="toggleSubmenu('gestione')">
                <i class="ti-settings"></i>Gestione
              </a>
              <ul class="submenu" :class="{'open': activeSubmenu=='gestione'}">

                <!-- === ADMIN (B) === -->
                <template v-if="tipologia=='B'">
                  <li><span>Anagrafiche e Risorse</span></li>
                  <li :class="[{'active': activePage=='admin-users'}]">
                    <router-link :to="{name: 'admin-users'}">
                      <i class="ti-user"></i>Utenti
                    </router-link>
                  </li>
                  <li :class="[{'active': activePage=='admin-team-types'}]">
                    <router-link :to="{name: 'admin-team-types'}">
                      <i class="ti-bookmark-alt"></i>Tipologie Squadra
                    </router-link>
                  </li>
                  <!--<li :class="[{'active': activePage=='geometra-squadra'}]">
                    <router-link :to="{name: 'geometra-squadra'}">
                      <i class="ti-crown"></i>Supervisore - Squadra
                    </router-link>
                  </li>-->
                  <li :class="[{'active': activePage=='admin-strade'}]">
                    <router-link :to="{name: 'admin-strade'}">
                      <i class="ti-truck"></i>Cantieri
                    </router-link>
                  </li>
                  <li :class="[{'active': activePage=='admin-modules'}]">
                    <router-link :to="{name: 'admin-modules'}">
                      <i class="ti-view-grid"></i>Moduli e asset associati
                    </router-link>
                  </li>
                  <li :class="[{'active': activePage=='admin-commessa'}]">
                    <router-link :to="{name: 'admin-commessa'}">
                      <i class="ti-briefcase"></i>Dettagli Commessa
                    </router-link>
                  </li>
                  <li class="divider"></li>
                </template>

                <!-- === ACCOUNT (tutti) === -->
                <li><span>Account</span></li>
                <li :class="[{'active': activePage=='change-password'}]">
                  <router-link :to="{name: 'change-password'}">
                    <i class="ti-key"></i>Cambia Password
                  </router-link>
                </li>
                <li>
                  <a href="#" @click="platformLogout">
                    <i class="ti-power-off"></i>Logout
                  </a>
                </li>
              </ul>
            </li>
            <!-- Bottone Nuovo Lavoro -->
            <li class="float-right-item" v-if="tipologia == 'B' || tipologia == 'G'">
              <router-link :to="{name: 'admin-create-work'}" class="btn-create-work">
                <i class="ti-plus mr-1"></i>Nuovo Lavoro
              </router-link>
            </li>
            <!-- Monitoring 
            <li class="has-submenu">
              <a href="https://www.system.innovambiente.it">
                <i class="ti-pulse"></i>Monitoraggio
              </a>
            </li>
-->
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { contextStore } from "@/utils/contextStore";

export default {
  props: ["activeDirectory", "activePage"],

  data () {
    return {
      notifications: [],
      isMenuOpen: false,
      activeSubmenu: ''
    }    
  },

  computed: {
    tipologia() {
      return localStorage.getItem('tipologia');
    },
    contextStore() {
      return contextStore;
    },
    commesse() {
      return contextStore.commesse;
    },
    activeModules() {
      return contextStore.activeModules;
    },
    selectedCommessaId: {
      get() {
        return contextStore.activeCommessaId;
      },
      set(val) {
        contextStore.setCommessa(val);
      }
    },
    selectedModuleId: {
      get() {
        return contextStore.selectedModuleId;
      },
      set(val) {
        contextStore.setSelectedModule(val);
      }
    }
  },

  async mounted() {
    if (this.tipologia !== 'D') {
      await contextStore.fetchCommesse();
    }
  },

  watch: {
    $route() {
      this.isMenuOpen = false;
      this.activeSubmenu = '';
    }
  },

  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },

    toggleSubmenu(name) {
      this.activeSubmenu = this.activeSubmenu === name ? '' : name;
    },

    // Mostra le notifiche
    showNotifications () {
      // this.$swal.fire(
      //   'The Internet?',
      //   'That thing is still around?',
      //   'question'
      // )
    },

    // Cancella il token ed effettua il logout
    platformLogout () {
      localStorage.removeItem('token')
      localStorage.removeItem('tipologia')
      localStorage.removeItem('fk_company')
      localStorage.removeItem('lotto')
      localStorage.removeItem('activeModuleId')
      this.$router.go()
    }
  }
};
</script>

<style scoped>
.topbar-context-widget {
  transition: all 0.3s ease;
}

.context-pill {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04), 0 1px 3px rgba(0, 0, 0, 0.02);
  border-radius: 24px;
  padding: 5px 16px;
  gap: 12px;
  transition: all 0.2s ease-in-out;
}

.context-pill:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.07);
}

.context-pill-item {
  position: relative;
}

.pill-icon {
  font-size: 1.2rem;
  line-height: 1;
}

.pill-select-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.pill-tag {
  font-size: 0.6rem;
  font-weight: 800;
  letter-spacing: 0.6px;
  color: #94a3b8;
  line-height: 1;
  margin-bottom: 2px;
  text-transform: uppercase;
}

.pill-select {
  border: none !important;
  background: transparent !important;
  color: #0f172a !important;
  font-size: 0.84rem !important;
  font-weight: 700 !important;
  padding: 0 20px 0 0 !important;
  height: auto !important;
  line-height: 1.2 !important;
  cursor: pointer;
  outline: none !important;
  box-shadow: none !important;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%252364748b' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-position: right center !important;
}

.pill-select:hover {
  color: #2563eb !important;
}

.pill-select option {
  background-color: #ffffff !important;
  color: #0f172a !important;
}

.pill-divider {
  width: 1px;
  height: 24px;
  background-color: #e2e8f0;
  margin: 0 4px;
}
</style>